import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

export default function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/verify-email/${token}`
        );

        setStatus('success');
        setMessage(response.data.msg);

        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/refer/login');
        }, 3000);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.msg || 'Email verification failed');
      }
    };

    verifyEmail();
  }, [navigate, token]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-backgroundLight">
      <img src="/Logo.png" alt="Plexys Logo" className="w-48 h-auto mb-6" />

      <div className="w-full max-w-md bg-white p-8 rounded shadow-md text-center">
        {status === 'verifying' && (
          <>
            <div className="mb-4">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
            </div>
            <h2 className="text-xl font-semibold mb-2">Verifying your email...</h2>
            <p className="text-gray-600">Please wait a moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="mb-4 text-green-500 text-6xl">✓</div>
            <h2 className="text-2xl font-semibold mb-2 text-green-600">Email Verified!</h2>
            <p className="text-gray-600 mb-4">{message}</p>
            <p className="text-sm text-gray-500">Redirecting to login in 3 seconds...</p>
            <Link
              to="/refer/login"
              className="inline-block mt-4 px-6 py-2 bg-primary text-white rounded hover:bg-blue-600"
            >
              Go to Login Now
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="mb-4 text-red-500 text-6xl">✗</div>
            <h2 className="text-2xl font-semibold mb-2 text-red-600">Verification Failed</h2>
            <p className="text-gray-600 mb-4">{message}</p>
            <p className="text-sm text-gray-500 mb-4">
              The verification link may be invalid or expired.
            </p>
            <Link
              to="/refer/login"
              className="inline-block mt-4 px-6 py-2 bg-primary text-white rounded hover:bg-blue-600"
            >
              Go to Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
